export const title = {
    fontSize: '32px',
    mb: 2,
    color: '#333',
    fontFamily: 'Jost-Regular',
    fontWeight: "bold",
};

export const subTitle = {
    mb: 2,
    // color: '#333',
    color: '#555',
    fontFamily: 'Jost-Regular',
    fontSize: '18px',
    fontWeight: "bold",
};

export const imageBoxStyle = {
    width: "100%",
    height: "180px",
    objectFit: "cover",
    borderRadius: 0,
    boxShadow: 0,
};

export const imageGridContainerStyle = {
    paddingTop: '20px',
    width: "100%", // Grid takes up full width
    justifyContent: "center", // Center the grid items
    pb: '30px',
};

export const textStyle = {
    mb: 1,
    color: '#555',
    fontFamily: 'Jost-Regular',
    fontSize: '22px',
};

export const priceText = {
    paddingTop: '25px',
    mb: 2,
    // color: '#333',
    color: '#555',
    fontFamily: 'Jost-Regular',
    fontSize: '28px',
    // fontWeight: "bold",
};
